import React from 'react';
import { Box, Typography } from '@mui/material';
import { BRAND } from '../../brand/brand';

/**
 * The lavender status pill from anipaw.net (`.pill`), used above a screen's headline to say
 * where in the provider flow the reader is. `tone` picks the dot colour.
 */
const TONES = {
  brand: BRAND.purple600,
  pending: '#F59E0B',
  live: '#16A34A',
};

const BrandPill = ({ label, tone = 'brand' }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 1,
      px: 1.75,
      py: 0.75,
      borderRadius: '999px',
      backgroundColor: BRAND.purple50,
      border: `1px solid ${BRAND.line}`,
    }}
  >
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: TONES[tone] ?? TONES.brand,
        boxShadow: `0 0 0 4px ${TONES[tone] ?? TONES.brand}29`,
        flexShrink: 0,
      }}
    />
    <Typography
      component="span"
      sx={{ fontSize: '0.8rem', fontWeight: 600, color: BRAND.ink700, letterSpacing: '0.01em' }}
    >
      {label}
    </Typography>
  </Box>
);

export default BrandPill;
